import { render, staticRenderFns } from "./ResourceBrowsing.vue?vue&type=template&id=00352de2&scoped=true"
import script from "./ResourceBrowsing.vue?vue&type=script&lang=js"
export * from "./ResourceBrowsing.vue?vue&type=script&lang=js"
import style0 from "./ResourceBrowsing.vue?vue&type=style&index=0&id=00352de2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00352de2",
  null
  
)

export default component.exports